var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-message-item px-3",class:{me: _vm.isMine}},[(_vm.value && _vm.author)?_c(_vm.component,{tag:"component",attrs:{"value":_vm.value,"is-mine":_vm.isMine,"author":_vm.author}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }